import { BannerStatic } from '../../components'
import * as actions from './slice'

const listPages = () => ({
  eventName: 'adminPagesList',
  onSuccess: [
    {
      action: actions.listPages,
      redux: true
    }
  ],
  onError: [
    (e) => {
      console.error('adminPagesList', e)
      BannerStatic.show({ label: 'Error loading pages', isError: true })
    }
  ]
})

const createPage = () => ({
  eventName: 'adminPagesCreate',
  onSuccess: [
    {
      action: actions.createPage,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Page has been successfully created' })
    }
  ],
  onError: [
    (e) => {
      console.error('adminPagesCreate', e)
      BannerStatic.show({ label: 'Error creating page', isError: true })
    }
  ]
})

const updatePage = () => ({
  eventName: 'adminPagesUpdate',
  onSuccess: [
    {
      action: actions.updatePage,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Page has been successfully updated' })
    }
  ],
  onError: [
    (e) => {
      console.error('adminPagesUpdate', e)
      BannerStatic.show({ label: 'Error updating page', isError: true })
    }
  ]
})

const deletePage = () => ({
  eventName: 'adminPagesDelete',
  onSuccess: [
    {
      action: actions.deletePage,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Page has been successfully deleted' })
    }
  ],
  onError: [
    (e) => {
      console.error('adminPagesDelete', e)
      BannerStatic.show({ label: 'Error deleting page', isError: true })
    }
  ]
})

export {
  listPages,
  createPage,
  updatePage,
  deletePage
}
